
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { OracleResponsysLinkedService } from 'app/model/linkedservice/oracle-responsys.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'ResponsysObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.OracleResponsys_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.OracleResponsys_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: OracleResponsysLinkedService.MODEL // Linked service redefined
        }
    }
})
export class OracleResponsysDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
